import TippyTooltip from "@stadium/ui/src/components/tooltip/tippy-tooltip";

import { KIT_TYPE_GLOBAL, WAREHOUSE_ITEM } from "@stadium/constants/kits";
import {
  KIT_COUNTRIES_MAPPING,
  DESCRIPTION_MAPPING,
  TOOLTIP_TEXT,
} from "@components/store/cart/kit-items/constants";

import styles from "./main.module.scss";

export const getSectionData = (bundleType) => {
  const { label, iso } = KIT_COUNTRIES_MAPPING[bundleType] || {};

  const heading = `Your ${label} kit is empty`;
  const getDescription = DESCRIPTION_MAPPING[bundleType];

  const ctaText = `Create ${label} Kit`;
  const addItemsCtaText = `Add ${label} Items`;

  return { heading, getDescription, ctaText, countryCode: iso?.toLowerCase(), addItemsCtaText };
};

export const getRemoveItemPayload = (items, qtyValue = 0) => {
  const payload = items.map((item) => {
    const { productId, catalogType, collectionId, id } = item;

    return {
      id,
      productId,
      quantity: qtyValue,
      catalogType,
      collectionId,
      _destroy: !qtyValue,
    };
  });

  return payload;
};

export const getProductTypeInfo = ({ bundleType, productType, isMobileDevice, nonUsFee }) => {
  const feeInfo =
    bundleType === KIT_TYPE_GLOBAL && productType === WAREHOUSE_ITEM ? (
      <p>Additional fees may apply</p>
    ) : (
      ""
    );

  const tooltipText = TOOLTIP_TEXT[bundleType][productType];

  if (isMobileDevice) {
    return <div className={styles.toolTipText}>{tooltipText(nonUsFee)}</div>;
  }

  return (
    <>
      {feeInfo}
      <TippyTooltip
        content={<div className={styles.toolTipText}>{tooltipText(nonUsFee)}</div>}
        isLightTheme
        arrow
        placement="top-start"
      >
        <span className={styles.iconInfo} />
      </TippyTooltip>
    </>
  );
};
